import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createStickerStockItem,
  getAllStickerStocksItems,
  getDataForEdit,
  deleteStickerStockItem,
  getBillListForVendor,
  getDataForAfterBill,
  adjustStickerStockItem,
} from "../../store/StickerStock/StickerStockSliceApi";

import {
  getAllVendorItems,
  // getStickerListItems,
} from "../../store/AppLevelApi/AppLevelApi";
import { stickerStockSliceAction } from "../../store/StickerStock/StickerStockSlice";
import { headTitle } from "../../utility/GetTableListName";
import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsStickerStocks } from "../../ConstantData/FormOptions";
//import constant form option to create duplicate field
import { AddMoreFormOptionsStickerStocks } from "../../ConstantData/AddMoreFormOptions";
//importing inital form data to store value state
import { InitialStickerStockFormData } from "../../ConstantData/InitialData";
//imporint form data error

//for only adjusted form
import { ErrorStickerStockFormData } from "../../ConstantData/ErrorOption";
import { adjustedFormStickerStock } from "../../ConstantData/AdjustedFormOption";
import { InitialAdjustData } from "../../ConstantData/AdjustInitialData";

function StickerStock() {
  const [showOtherFormBtn, setShowOtherFormBtn] = useState(false); //for only adjust

  const [adjustInitialData, setAdjustInitialData] = useState(InitialAdjustData);

  let newFormOptionsStickerStock = JSON.parse(
    JSON.stringify(AddMoreFormOptionsStickerStocks)
  );

  let newFormOptionsStickerStockText = JSON.parse(
    JSON.stringify(FormOptionsStickerStocks)
  );
  let newAdjustedFormStickerStock = JSON.parse(
    JSON.stringify(adjustedFormStickerStock)
  );
  // let billDataList = useSelector((state) => state.StickerStock.billDataList);

  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getProductItems("name"));
    // dispatch(getAllStickerStocksItems());
    // dispatch(getAllVendorItems());
    // dispatch(getStickerListItems());
  }, []);

  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const stickerStockList = useSelector(
    (state) => state.stickerstock.stickerStockList
  );

  //for normal form input data initilization
  const InitialFormDataStore = useSelector(
    (state) => state.stickerstock.initialData
  );
  //for normal duplicate form input data initilization
  let InitialFormDuplicateDataStore = useSelector(
    (state) => state.stickerstock.initialDuplicateData
  );

  const stickerStockEditData = useSelector(
    (state) => state.stickerstock.dataEdit
  );
  let stickerStockFormError = useSelector(
    (state) => state.stickerstock.errorData
  );

  let isError = useSelector((state) => state.stickerstock.isError);
  stickerStockFormError = {
    ...ErrorStickerStockFormData,
    ...stickerStockFormError,
  };
  const vendorList = useSelector((state) => state.applevel.vendorList);

  const billList = useSelector((state) => state.stickerstock.billList);

  function addOptionForSelectFieldDuplicate(
    FormOption,
    list,
    optionName,
    type
  ) {
    if (type === "duplicate") {
      newFormOptionsStickerStock = FormOption.map((item) => {
        if (item?.labelName === optionName) {
          item.options = list;
        }

        return item;
      });
    } else {
      newAdjustedFormStickerStock = adjustedFormStickerStock.map((item) => {
        if (item?.labelName === optionName) {
          item.options = list;
        }

        return item;
      });
    }
  }
  function addOptionForSelectField(FormOption, list, optionName) {
    newFormOptionsStickerStockText = FormOption.map((item) => {
      if (item?.labelName === optionName) {
        item.options = list;
      }

      return item;
    });
  }

  if (vendorList.length > 0) {
    // to chage subquality option coming from server4
    addOptionForSelectField(
      newFormOptionsStickerStockText,
      vendorList,
      "Vendor"
    );
  }

  if (billList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      adjustedFormStickerStock,
      billList,
      "Bill Number",
      "adjusted"
    );
  } else {
    addOptionForSelectFieldDuplicate(
      adjustedFormStickerStock,
      [],
      "Bill Number",
      "adjusted"
    );
  }

  const setDataForAdjust = (type) => {
    if (vendorList.length > 0) {
      addOptionForSelectFieldDuplicate(
        adjustedFormStickerStock,
        vendorList,
        "Vendor",
        "adjusted"
      );
    }
  };

  const inputAdjustHandler = (name, value) => {
    //only for adjust not need for all

    const formData = JSON.parse(JSON.stringify(adjustInitialData)); //deep copy
    if (name === "bill_number") {
      setShowOtherFormBtn((prevState) => !prevState);
      // dispatch(getDataForAfterBill(value.value));
    }
    // if (name === "vendor") dispatch(getBillListForVendor(value.value));
    formData[name] = value;
    setAdjustInitialData(formData);
  };

  const headTitleLabel = headTitle(FormOptionsStickerStocks, [
    "Sticker Type",
    "Quantity",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialStickerStockFormData}
      getDataForEdit={getDataForEdit}
      delteFun={deleteStickerStockItem}
      createFun={createStickerStockItem} //create function coming from store
      FormOptions={newFormOptionsStickerStockText}
      // NewFormOptions={newFormOptionsStickerStock}
      OptionName="Create Sticker Stock"
      OptionNameList="Sticker Stock"
      generalList={stickerStockList}
      headTitle={headTitleLabel}
      EditData={stickerStockEditData}
      isError={isError}
      ErrorData={stickerStockFormError}
      InitialFormDataStore={InitialFormDataStore}
      InitialFormDuplicateDataStore={InitialFormDuplicateDataStore}
      setErrorData={stickerStockSliceAction.setErrorData}
      generalModuleList={vendorList} //list to add different module
      isNotDeleteBtn={true}
      extraAddBtn={false}
      extraButtonText={"Add Sticker"}
      FormStyle={"!w-[60%] !h-[40rem] custom-scroll-for-nav overflow-y-scroll "}
      secondCreateBtn={false} // to create second button to add extra form
      isSuccess={isSuccess}
      needAdjust={true} //it is used if there is no edit but need adjust
      adjustedFormStock={adjustedFormStickerStock} //it is used if there is no edit but need adjust
      setDataForAdjust={setDataForAdjust}
      inputAdjustHandler={inputAdjustHandler} //it is used if there is no edit but need adjust
      InitialAdjustData={adjustInitialData} //it is used if there is no edit but need adjust
      listForLength={{ billList }}
      showOtherFormBtn={showOtherFormBtn} // //it is used if there is no edit but need adjust
      createAdjust={adjustStickerStockItem}
      notShowEditBtn={true} //use when you dont need edit btn
    />
  );
}

export default StickerStock;
